<template>
  <div class="continer">
    <div class="company">
      <div class="first">
        <span>董事长(总经理)</span>
      </div>
      <div class="second">
        <img src="../../assets/img/640.png" alt="">
      </div>
      <div class="thired">
        <ul>
          <li v-for="(item,index) in phoneList" :key="index" :class="{active:showPhone == index}">
            <span @click="onChange(item,index)">{{item.name}}</span>
            <em>{{item.phone}}</em>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPhone:0,
      phoneList:[
        {
          code:0,
          name:'计财办公室',
          phone:'0475-6185518'
        },
        {
          code:1,
          name:'总工办公室',
          phone:'赵亚芝  /  电话 : 0475-6185516'
        },
        {
          code:2,
          name:'建筑审查室',
          phone:'0475-6185517'
        },
        {
          code:3,
          name:'结构审查室',
          phone:'0475-6185517'
        },
        {
          code:4,
          name:'勘察审查室',
          phone:'0475-6185517'
        },
        {
          code:5,
          name:'设备审查室',
          phone:'0475-6185517'
        },
      ]
    }
  },
  methods:{
    onChange(item,index){
      this.showPhone = index
    }
  }
}
</script>
<style lang="stylus" scoped>
.active
  span 
    background #ffffff !important 
    color #016bff
  em 
    display inline-block !important 
.continer 
  width 100%
  color #333
  .company
    display flex
    flex-wrap wrap 
    padding 50px 
    box-sizing border-box
    height 360px
    .thired
      font-size 12px
      ul 
        // margin 0
        padding 0
        li  
          margin-bottom 34px
          height 30px
          span 
            display inline-block
            width 110px
            height 28px
            text-align center
            line-height 28px
            background rgba(133,226,223,1)
            box-shadow 0px 3px 6px 0px rgba(0, 0, 0, 0.08)
            border-radius 4px
            // vertical-align middle
            margin-right 20px
            cursor pointer
          em 
            display none 
            font-size 12px
            height 28px
            line-height 28px
            // height 30px
            vertical-align middle
            border-bottom 1px soild #ccc
            // border-bottom 1px soild #ccc
    .second
      img 
        display block
        margin-top 8px
    .first 
      // margin auto 0
      font-size 12px
      margin-top 150px
      span 
        display block
        background #FCC87D
        width 140px
        height 36px
        line-height 36px 
        text-align center
        box-shadow:0px 3px 6px 0px rgba(0, 0, 0, 0.08)
        border-radius:4px
</style>
